// extracted by mini-css-extract-plugin
export var basicSlide = "style-mod--basic-slide--bb4ca";
export var basicSlideContent = "style-mod--basic-slide-content--e0dbf";
export var basicSlideImg = "style-mod--basic-slide-img--e7cab";
export var basicSlideItem = "style-mod--basic-slide-item--d0d65";
export var basicSlideSubtitle = "style-mod--basic-slide-subtitle--0b382";
export var basicSlideTag = "style-mod--basic-slide-tag--19f95";
export var basicSlideTitle = "style-mod--basic-slide-title--9c810";